import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "variator__slider" }
const _hoisted_2 = {
  key: 0,
  class: "variator__slider-labels"
}
const _hoisted_3 = { class: "variator__slider-label" }
const _hoisted_4 = { class: "variator__slider-label" }
const _hoisted_5 = { class: "variator__slider-numberline" }
const _hoisted_6 = ["data-badge-number", "data-test"]
const _hoisted_7 = {
  key: 0,
  class: "variator__slider-numberline-item-label"
}
const _hoisted_8 = ["aria-valuemin", "aria-valuemax", "aria-valuenow", "data-badge-number", "aria-labelledby"]

import { onUnmounted, nextTick, useTemplateRef, ref, onMounted, watch, computed } from "vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { type Variator, useVariator } from "./use-variator";


export default /*@__PURE__*/_defineComponent({
  __name: 'lottery-variator',
  props: /*@__PURE__*/_mergeModels({
    snapPoints: {},
    labelledById: {},
    topNumbers: { type: Boolean },
    minText: {},
    maxText: {},
    shine: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const model = _useModel<number>(__props, "modelValue");

const sliderBarEl = useTemplateRef("sliderBarEl");
const sliderBarInnerEl = useTemplateRef("sliderBarInnerEl");
const sliderBarBadgeEl = useTemplateRef("sliderBarBadgeEl");
const sliderNumberlineItemElems = ref<HTMLElement[] | null>(null);
const minValue = computed(() => __props.snapPoints[0]);
const maxValue = computed(() => __props.snapPoints[__props.snapPoints.length - 1]);

if (model.value > maxValue.value) model.value = maxValue.value;

const updateBadgeCount = (count: number) => {
    model.value = count;
};

let variator: Variator;
const initVariator = async () => {
    await nextTick();

    variator = useVariator({
        containerEl: sliderBarEl.value,
        barEl: sliderBarInnerEl.value,
        badgeEl: sliderBarBadgeEl.value,
        sliderElems: sliderNumberlineItemElems.value,
        snapPoints: __props.snapPoints,
        startValue: model.value,
        updateBadgeCount,
    });
};

watch(
    () => __props.snapPoints.length,
    () => {
        if (variator) {
            variator.destroy();
            initVariator();
        }
    }
);

watch(model, (modelValue) => {
    variator.setCurrentValue(modelValue);
});

function decrementValue() {
    const currentIndex = __props.snapPoints.indexOf(model.value);
    if (currentIndex > 0) {
        updateBadgeCount(__props.snapPoints[currentIndex - 1]);
    }
}

function incrementValue() {
    const currentIndex = __props.snapPoints.indexOf(model.value);
    if (currentIndex < __props.snapPoints.length - 1) {
        updateBadgeCount(__props.snapPoints[currentIndex + 1]);
    }
}

function onKeyDown(e: KeyboardEvent) {
    if (e.key === "ArrowLeft") {
        decrementValue();
    } else if (e.key === "ArrowRight") {
        incrementValue();
    }
}

const sliderBarElClickHandler = (e: MouseEvent) => {
    const barStartX = sliderBarEl.value.getBoundingClientRect().x;
    const clickX = e.clientX - barStartX;
    // get an array of dots centers
    const dotsXArray = sliderNumberlineItemElems.value.map(
        (el) => el.getBoundingClientRect().x - barStartX + el.clientWidth / 2
    );
    //find index of the closest dot center from clickX
    const closestIndex = dotsXArray.reduce(
        (closestIndex, num, index) =>
            Math.abs(num - clickX) < Math.abs(dotsXArray[closestIndex] - clickX) ? index : closestIndex,
        0
    );
    updateBadgeCount(__props.snapPoints[closestIndex]);
};

onMounted(() => {
    initVariator();
    sliderBarEl.value.addEventListener("click", sliderBarElClickHandler);
});

onUnmounted(() => {
    variator?.destroy();
    sliderBarEl.value?.removeEventListener("click", sliderBarElClickHandler);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["variator", { 'variator--top-numbers': _ctx.topNumbers }]),
    onKeydown: onKeyDown
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.minText && _ctx.maxText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.minText), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.maxText), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("ol", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.snapPoints, (point, idx) => {
          return (_openBlock(), _createElementBlock("li", {
            key: idx,
            class: _normalizeClass(["variator__slider-numberline-item", [
                        { 'variator__slider-numberline-item--active': point === model.value },
                        {
                            'variator__slider-numberline-item--inactive-smaller': idx < _ctx.snapPoints.indexOf(model.value),
                        },
                    ]]),
            ref_for: true,
            ref_key: "sliderNumberlineItemElems",
            ref: sliderNumberlineItemElems,
            "data-badge-number": point,
            "data-test": `column-count-${point}`
          }, [
            (_ctx.topNumbers)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(point), 1))
              : _createCommentVNode("", true)
          ], 10, _hoisted_6))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: "variator__slider-bar",
        ref_key: "sliderBarEl",
        ref: sliderBarEl
      }, [
        _createElementVNode("div", {
          class: "variator__slider-bar-inner",
          ref_key: "sliderBarInnerEl",
          ref: sliderBarInnerEl
        }, null, 512),
        _createElementVNode("div", {
          class: "variator__slider-bar-badge",
          role: "slider",
          "aria-valuemin": minValue.value,
          "aria-valuemax": maxValue.value,
          "aria-valuenow": model.value,
          ref_key: "sliderBarBadgeEl",
          ref: sliderBarBadgeEl,
          "data-badge-number": model.value,
          "aria-labelledby": _ctx.labelledById,
          tabindex: 0,
          "data-test": "column-slider"
        }, [
          _createTextVNode(_toDisplayString(model.value) + " ", 1),
          _withDirectives(_createVNode(WebpImage, {
            class: "variator__slider-bar-shine",
            src: "/frontend/web/img/lotteries/variator/variator-shine.svg",
            alt: ""
          }, null, 512), [
            [_vShow, _ctx.shine && model.value > 1]
          ])
        ], 8, _hoisted_8)
      ], 512)
    ])
  ], 34))
}
}

})